/* Solene - bundle tiers in Horizon's sticky add-to-cart bar, iOS Safari toolbar
   handling, and styling for the power section. */
(function () {
  var BAR = '.sticky-add-to-cart__bar';

  function readTiers() {
    var src = document.querySelector('.sol-tiers');
    if (!src) return null;
    var tiers = [];
    src.querySelectorAll('.sol-tier').forEach(function (t) {
      var q = t.getAttribute('data-qty');
      var p = t.querySelector('.sol-tier__price');
      if (q && p) tiers.push({ qty: q, price: p.textContent.trim() });
    });
    return tiers.length ? tiers : null;
  }

  function qtyInput() { return document.querySelector('input[name="quantity"]'); }

  function styles() {
    if (document.getElementById('sol-sticky-tiers-css')) return;
    var s = document.createElement('style');
    s.id = 'sol-sticky-tiers-css';
    s.textContent =
      '.sticky-add-to-cart__bar{flex-wrap:wrap;row-gap:10px}' +
      '.sol-sticky-tiers{display:flex;gap:8px;width:100%;order:-1}' +
      '.sol-sticky-tier{flex:1 1 0;display:flex;flex-direction:column;align-items:center;gap:1px;' +
      'padding:7px 4px;border-radius:8px;cursor:pointer;border:1px solid rgba(196,149,106,.55);' +
      'background:transparent;font-family:inherit;line-height:1.15;' +
      'transition:background .15s,border-color .15s,color .15s}' +
      '.sol-sticky-tier__q{font-size:12px;font-weight:600;letter-spacing:.04em;color:#1c1209}' +
      '.sol-sticky-tier__p{font-size:11px;color:#6E5A45;font-variant-numeric:tabular-nums}' +
      '.sol-sticky-tier[aria-pressed="true"]{background:#1c1209;border-color:#1c1209}' +
      '.sol-sticky-tier[aria-pressed="true"] .sol-sticky-tier__q,' +
      '.sol-sticky-tier[aria-pressed="true"] .sol-sticky-tier__p{color:#f5f0e8}' +
      '@media screen and (min-width:750px){.sol-sticky-tiers{order:0;width:auto;flex:1 1 260px}}' +
      '@media screen and (max-width:749px){' +
      'sticky-add-to-cart .sticky-add-to-cart__bar{' +
      'width:calc(100% - 24px);max-width:none;border-radius:20px;' +
      'bottom:calc(12px + var(--sol-vv-offset,0px) + env(safe-area-inset-bottom,0px));' +
      'padding:10px;column-gap:10px;row-gap:8px;' +
      'background:rgba(245,240,232,.88);' +
      '-webkit-backdrop-filter:saturate(180%) blur(18px);backdrop-filter:saturate(180%) blur(18px);' +
      'border:1px solid rgba(196,149,106,.35);' +
      'box-shadow:0 8px 28px rgba(28,18,9,.18),0 1px 2px rgba(28,18,9,.10);' +
      'transition:bottom .12s linear}' +
      'sticky-add-to-cart .sticky-add-to-cart__image,' +
      'sticky-add-to-cart .sticky-add-to-cart__info{display:none}' +
      'sticky-add-to-cart .sticky-add-to-cart__price{display:none}' +
      'sticky-add-to-cart .sticky-add-to-cart__bar .sticky-add-to-cart__button,' +
      'sticky-add-to-cart .sticky-add-to-cart__bar .sol-shop-btn{' +
      'width:0;min-width:0;padding-inline:8px}' +
      'sticky-add-to-cart .sticky-add-to-cart__bar .sticky-add-to-cart__button{order:2;flex:1 1 0}' +
      'sticky-add-to-cart .sticky-add-to-cart__bar .sol-shop-btn{flex:1 1 0}' +
      '.sol-shop-btn{order:3;height:var(--height-buy-buttons,52px);display:flex;' +
      'align-items:center;justify-content:center;gap:6px;border:0;border-radius:8px;' +
      'cursor:pointer;background:#5a31f4;color:#fff;font-family:inherit;' +
      'font-size:15px;font-weight:600;letter-spacing:.01em}' +
      '.sol-shop-btn svg{flex:0 0 auto}' +
      '.sol-sticky-tier{padding:5px 4px}' +
      '.sol-sticky-tier__q{font-size:11px}.sol-sticky-tier__p{font-size:10px}' +
      '}';
    document.head.appendChild(s);
  }

  /* iOS Safari positions fixed elements against the layout viewport, so a
     bottom:0 bar hides behind the browser toolbar. Track the real overlap. */
  function trackViewport() {
    var vv = window.visualViewport;
    if (!vv || window.__solVVTracked) return;
    window.__solVVTracked = true;
    function place() {
      var overlap = Math.max(0, Math.min(160,
        Math.round(document.documentElement.clientHeight - (vv.height + vv.offsetTop))));
      document.documentElement.style.setProperty('--sol-vv-offset', overlap + 'px');
    }
    place();
    vv.addEventListener('resize', place);
    vv.addEventListener('scroll', place);
    window.addEventListener('orientationchange', function () { setTimeout(place, 250); });
  }

  /* Shop Pay is a web component: it cannot be cloned and moving it would strip
     it from the product form. Proxy a button that clicks the real one instead. */
  function addShopButton(bar) {
    if (bar.querySelector('.sol-shop-btn')) return;
    if (!document.querySelector('.shopify-payment-button shop-pay-wallet-button')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sol-shop-btn';
    b.setAttribute('aria-label', 'Buy with Shop Pay');
    b.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M7 8V6.5a5 5 0 0 1 10 0V8h2.2a.8.8 0 0 1 .8.75l.9 11.4a1.6 1.6 0 0 1-1.6 1.85' +
      'H4.7a1.6 1.6 0 0 1-1.6-1.85L4 8.75A.8.8 0 0 1 4.8 8H7Zm2 0h6V6.5a3 3 0 1 0-6 0V8Z" ' +
      'fill="currentColor"/></svg><span>Shop Pay</span>';
    b.addEventListener('click', function () {
      var real = document.querySelector('.shopify-payment-button shop-pay-wallet-button') ||
                 document.querySelector('.shopify-payment-button button');
      if (real) real.click();
    });
    bar.appendChild(b);
  }

  function paint(wrap, tiers, q) {
    wrap.querySelectorAll('.sol-sticky-tier').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-qty') === String(q)));
    });
    var tier = tiers.filter(function (t) { return t.qty === String(q); })[0];
    var priceEl = document.querySelector(BAR + ' .sticky-add-to-cart__price');
    if (tier && priceEl) {
      priceEl.innerHTML = '<span class="price-item__group price">' + tier.price + '</span>';
    }
  }

  function inject() {
    var bar = document.querySelector(BAR);
    if (!bar || bar.querySelector('.sol-sticky-tiers')) return;
    var tiers = readTiers();
    if (!tiers) return;

    styles();
    var wrap = document.createElement('div');
    wrap.className = 'sol-sticky-tiers';
    wrap.innerHTML = tiers.map(function (t) {
      return '<button type="button" class="sol-sticky-tier" data-qty="' + t.qty + '" aria-pressed="false">' +
        '<span class="sol-sticky-tier__q">' + t.qty + ' Unit' + (t.qty > 1 ? 's' : '') + '</span>' +
        '<span class="sol-sticky-tier__p">' + t.price + '</span></button>';
    }).join('');

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.sol-sticky-tier');
      if (!b) return;
      var q = b.getAttribute('data-qty');
      var input = qtyInput();
      if (input) {
        input.value = q;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.querySelectorAll('.sol-tier').forEach(function (t) {
        t.classList.toggle('is-selected', t.getAttribute('data-qty') === q);
      });
      paint(wrap, tiers, q);
    });

    document.querySelectorAll('.sol-tier').forEach(function (t) {
      t.addEventListener('click', function () { paint(wrap, tiers, t.getAttribute('data-qty')); });
    });

    bar.insertBefore(wrap, bar.firstChild);
    var input = qtyInput();
    paint(wrap, tiers, input ? input.value : tiers[0].qty);
  }

  /* Shopify's payment component renders asynchronously, so the shop button has
     to be retried rather than attached once alongside the tiers. */
  function tick() {
    styles();
    inject();
    var bar = document.querySelector(BAR);
    if (bar) addShopButton(bar);
  }

  function boot() {
    trackViewport();
    tick();
    var mo = new MutationObserver(function () { tick(); });
    mo.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    var iv = setInterval(function () {
      tick();
      if (++tries > 20 || document.querySelector('.sol-shop-btn')) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
